<template>
    <div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="任务ID"></el-table-column>
                <el-table-column prop="taskType" label="任务类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType == 1">演出</span>
                        <span v-else-if="scope.row.taskType == 2">众筹</span>
                        <span v-else-if="scope.row.taskType == 3">周边</span>
                    </template>
                </el-table-column>
                <el-table-column prop="taskStatus" label="任务状态" :min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskStatus == 1">进行中</span>
                        <span v-else-if="scope.row.taskStatus == 2" class="color-success">全部完成</span>
                        <span v-else-if="scope.row.taskStatus == 3" class="color-danger">部分失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderCount" label="总退款数"></el-table-column>
                <el-table-column prop="refundTotalAmountFormat" label="总退款金额" min-width="90"></el-table-column>
                <el-table-column prop="successCount" label="已成功数"></el-table-column>
                <el-table-column prop="successAmountFormat" label="已成功金额" min-width="90"></el-table-column>
                <el-table-column prop="failureCount" label="失败数"></el-table-column>
                <el-table-column prop="failureAmountFormat" label="失败金额"></el-table-column>
                <!-- <el-table-column prop="orderCount" label="订单数" :min-width="100"></el-table-column> -->
                <!-- <el-table-column prop="refundAmountFormat" label="待退款金额" :min-width="100"></el-table-column> -->
                <el-table-column prop="createUserName" label="操作人" :min-width="100"></el-table-column>
                <el-table-column prop="createTime" label="生成时间" :min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" :width="240">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/batchRefund/summaryInformation')" type="text" size="small"
                            @click="$refs.summaryView.show(scope.row.id)">查看统计</el-button>
                        <el-button type="text" size="small" @click="viewOrderDetail(scope.row)">查看订单明细</el-button>
                        <el-button v-if="scope.row.taskStatus == 3 && $utils.have('/batchRefund/refreshTask')"
                            type="text" size="small" @click="reTask(scope.row)">重新执行任务</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <summary-view ref="summaryView"></summary-view>
    </div>
</template>

<script>

import SummaryView from './components/summary.vue';

export default {
    components: { SummaryView },
    data() {
        this.defaultParams = {
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return {
            data: null,
            dataList: null,
            params: { ...this.defaultParams },
            listLoading: true,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        async getDataList() {
            this.listLoading = true;

            const res = await this.$request({
                url: '/batchRefund/list',
                method: 'post',
                data: { ...this.params }
            }).catch(() => {
                return { data: { state: '0', msg: '请求错误' } };
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if (state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        viewOrderDetail(row) {
            const { taskType, id } = row;
            // 1演出批量退款，2众筹批量退款，3周边批量退款
            switch (taskType) {
                case 1: // 演出
                    this.$router.push({ path: '/finance/activity/refund/list', query: { searchType: 3, refundStatus: -1, searchValue: id } });
                    break;
                case 2: // 演出
                    this.$router.push({ path: '/finance/raise/refund/list', query: { searchType: 3, refundStatus: -1, searchValue: id } });
                    break;
            }
        },
        //重新执行任务
        reTask(row) {
            this.$confirm('确定重新执行任务？<br>重新执行任务后，如果任务仍然失败，请联系研发', '提示', {
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
                confirmButtonText: '重新执行',
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/batchRefund/refreshTask',
                    method: 'post',
                    params: { taskId: row.id }
                }).then(res => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        setTimeout(() => {
                            this.getDataList();
                        }, 500)

                    } else {
                        this.$message.error(msg || '请求失败');
                        this.listLoading = false;
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                    this.listLoading = false;
                })
            }).catch(() => { });
        }
    }
}
</script>